module.exports = __webpack_public_path__ + "static/media/logo.810dbe0f.svg";